const STORAGE_KEY = 'bajie_sni_sessions'

function readSessions () {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (error) {
    return {}
  }
}

function writeSessions (sessions) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions))
  } catch (error) {
    // localStorage can be unavailable in restricted browser modes.
  }
}

export function isValidSniSn (sn) {
  return !!sn?.trim()
}

export function getSniSession (sn) {
  const sessions = readSessions()
  return sessions[sn] || null
}

export function saveSniSession (sn, session) {
  if (!isValidSniSn(sn) || !session?.token) {
    return
  }
  const sessions = readSessions()
  sessions[sn] = {
    ...session,
    sn,
    updatedAt: Date.now()
  }
  writeSessions(sessions)
}

export function clearSniSession (sn) {
  const sessions = readSessions()
  delete sessions[sn]
  writeSessions(sessions)
}
